import React from "react";
import { AlertCircle, CheckCircle } from "lucide-react";

export default function CompareSection() {
  return (
    <section className="tfl-compare" aria-label="AI assistants vs ThreatForge comparison">
      <div className="tfl-blob tfl-compare__blob" aria-hidden="true">
        <div className="tfl-blob__shape" />
      </div>

      <div className="tfl-compare__header">
        <div className="tfl-eyebrow" style={{ justifyContent: "center" }}>Why Purpose-Built Threat Modeling?</div>
        <h2 className="tfl-display">
          AI finds threats in seconds. The bottleneck is proving coverage.
        </h2>
        <p className="tfl-body-lg" style={{ maxWidth: "620px", margin: "0 auto" }}>
          Generic LLM prompts generate superficial lists. ThreatForge anchors AI in deterministic graph architecture, verified control taxonomies, and audit-ready proof.
        </p>
      </div>

      <div className="tfl-compare__table">
        {/* Generic LLMs Column */}
        <div className="tfl-compare__col tfl-compare__col--a">
          <div className="tfl-compare__col-head">
            <div className="tfl-compare__col-icon tfl-compare__col-icon--a">
              <AlertCircle size={18} color="#fb7185" />
            </div>
            <span>Generic AI &amp; Prompt Tools</span>
          </div>

          <ul className="tfl-compare__items">
            <li className="tfl-compare-item">
              <span className="tfl-compare-item__icon tfl-compare-item__icon--x">✕</span>
              <span>Generates generic threat lists based on prompt luck</span>
            </li>
            <li className="tfl-compare-item">
              <span className="tfl-compare-item__icon tfl-compare-item__icon--x">✕</span>
              <span>Output varies by user, model version, and context window</span>
            </li>
            <li className="tfl-compare-item">
              <span className="tfl-compare-item__icon tfl-compare-item__icon--x">✕</span>
              <span>No direct link between threats and system architecture</span>
            </li>
            <li className="tfl-compare-item">
              <span className="tfl-compare-item__icon tfl-compare-item__icon--x">✕</span>
              <span>One-off static markdown document that becomes stale immediately</span>
            </li>
            <li className="tfl-compare-item">
              <span className="tfl-compare-item__icon tfl-compare-item__icon--x">✕</span>
              <span>No compliance mapping (NIST, PCI-DSS, ISO, SOC 2)</span>
            </li>
          </ul>
        </div>

        {/* ThreatForge Column */}
        <div className="tfl-compare__col tfl-compare__col--b">
          <div className="tfl-compare__col-head">
            <div className="tfl-compare__col-icon tfl-compare__col-icon--b">
              <CheckCircle size={18} color="#34d399" />
            </div>
            <span>ThreatForge Platform</span>
          </div>

          <ul className="tfl-compare__items">
            <li className="tfl-compare-item">
              <span className="tfl-compare-item__icon tfl-compare-item__icon--c">✓</span>
              <span><strong>Maps threats to your exact architecture graph</strong>, not generic averages</span>
            </li>
            <li className="tfl-compare-item">
              <span className="tfl-compare-item__icon tfl-compare-item__icon--c">✓</span>
              <span><strong>Deterministic &amp; repeatable</strong>: Same architecture in, verified threats out</span>
            </li>
            <li className="tfl-compare-item">
              <span className="tfl-compare-item__icon tfl-compare-item__icon--c">✓</span>
              <span><strong>Complete traceability</strong> from threat to control to code</span>
            </li>
            <li className="tfl-compare-item">
              <span className="tfl-compare-item__icon tfl-compare-item__icon--c">✓</span>
              <span><strong>Continuously updated</strong> as architecture diagrams or code change</span>
            </li>
            <li className="tfl-compare-item">
              <span className="tfl-compare-item__icon tfl-compare-item__icon--c">✓</span>
              <span><strong>180+ Frameworks</strong> with audit-ready PDF/DOCX reports</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
